<script>
    export let text;
    export let centered;
    export let spinnerBg = 'rgba(157, 52, 206, 1)';
    export let padding = '0';

    $: gradientString = `conic-gradient(from 154deg at 50% 50%, rgba(0, 0, 0, 0) 34%, ${spinnerBg} 100%)`;
</script>

<div class="loader" style={ centered ? 'justify-content: center' : '' } style:padding={padding}>
    <div class="spinner" style:background={gradientString}></div>
    {#if text}
        <div class="text">{text}</div>
    {/if}
</div>

<style lang="less">
    .loader {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;

        .spinner {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            // background: conic-gradient(from 154deg at 50% 50%, rgba(15, 144, 192, 1) 34%, rgba(157, 52, 206, 1) 100%);
            // background: conic-gradient(from 154deg at 50% 50%, rgba(0, 0, 0, 0) 34%, rgba(157, 52, 206, 1) 100%);
            animation-name: rotate;
            animation-duration: .7s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .text {
            margin-left: 10px;
            color: var(--color-gray-350);
            font-family: var(--font-alt);
            letter-spacing: 3px;
            font-size: 14px;
        }
    }
</style>